// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__VExgS","logo":"Sidebar_logo__JFHgn","link":"Sidebar_link__K+8At"};